<template>
  <div>
    <div class="mb-1 text-sm">
      <PTranslation k="CreateOrUpdateUserDialog.SecondaryLocations" />
    </div>
    <div 
      class="p-2 text-sm bg-white border border-gray-400 rounded"
      :class="{
        'bg-gray-50 border-gray-300 text-gray-400 cursor-not-allowed': disabled
      }"
    >
      <ul class="mb-2" v-if="userLocations.length > 0">
        <li class="px-2 py-1 border-b border-gray-200" v-for="(location, index) in userLocations" :key="index">          
          {{ location.name }} ({{ location.id }})          
        </li>
      </ul>    
      <div class="px-2">
        <button 
          class="text-green-500 underline" 
          :class="{
            'text-green-300': disabled
          }"
          @click.prevent="editSecondaryLocationsVisible = true"
        >
          <PTranslation k="Common.Actions.Select" />...</button>
      </div>
    </div>
    <div v-if="editSecondaryLocationsVisible" class="absolute inset-0 z-10 flex items-center justify-center overlay">
      <div class="w-full m-4 bg-white shadow-lg rounded-md">
        <div class="p-4 bg-gray-100 border-b border-gray-300 rounded-t-md">
          <PTranslation k="CreateOrUpdateUserDialog.SelectSecondaryLocations" />
        </div>
        <div class="flex flex-col p-4 overflow-y-auto max-h-96 space-y-2">
          <div v-for="(location, index) in secondaryLocations" :key="index">
            <PCheckbox 
              :label="`${location.name} (${location.id})`" 
              :value="isSelected(location.id)" 
              @input="toggle(location.id)" 
            />
          </div>
        </div>
        <div class="flex justify-end p-4 bg-gray-100 border-t border-gray-300 rounded-b-md">
          <PButton @click="editSecondaryLocationsVisible = false">
            <PTranslation k="Common.Actions.Close" />
          </PButton>
        </div>
      </div>
    </div>      
  </div>
</template>

<script>
import { filter, findIndex } from "lodash"
export default {  
  props: {
    value: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    locations: {
      type: Array,
      default: () => []
    },
    userLocationId: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      locationIds: [],
      editSecondaryLocationsVisible: false     
    }
  },
  computed: {
    // secondary locations
    secondaryLocations () {
      return filter(this.locations, l => l.id !== this.userLocationId)
    },
    // secondary locations selected
    userLocations () {
      return filter(this.secondaryLocations, l => findIndex(this.value, id => id === l.id) !== -1)
    }
  },
  methods: {
    toggle (locationId) {
      let arr = [...this.value]
      const index = findIndex(this.value, id => id === locationId)      
      if (index === -1) {
        arr.push(locationId)
      }
      else {
        arr.splice(index, 1)        
      }
      this.$emit("input", arr)
    },

    isSelected (locationId) {
      return findIndex(this.userLocations, l => l.id === locationId) !== -1
    }
  },
}
</script>

<style scoped>
  .overlay {
    background-color: rgba(0,0,0,.5);
    @apply rounded-lg;
  }
</style>
